import React from 'react';
import { Link } from 'react-router-dom';

function ButtonMailTo(props) {
  return (
    <Link
      to="#"
      className={props.class}
      onClick={(e) => {
        window.open(props.link);
        e.preventDefault();
      }}
    >
      {props.children}
    </Link>
  );
}

export default ButtonMailTo;
